<template>
  <el-form-item prop="roles" style="margin-left: 20px; margin-bottom: 10px; width: 95%;" :ref="questionRef">
    <template slot="label">
      <template v-if="questionData.questionHoverLabel">
        <el-tooltip :content="questionData.questionHoverLabel" placement="right-start" effect="light">
          <span :style="questionData.questionFontWeight ? `font-weight: ${questionData.questionFontWeight};` : ''">
            {{ questionData.questionLabel }}
            <i class="el-icon-info"></i>
          </span>
        </el-tooltip>
      </template>
      <template v-else>
        <span :style="questionData.questionFontWeight ? `font-weight: ${questionData.questionFontWeight};` : ''">{{ questionData.questionLabel }}</span>
      </template>
    </template>
    <div v-for="(suboptionset, index2) in questionData.questionOptionSetList" :key="index2">
      <stu-radio-group :changeFunction="changeFunction" v-if="suboptionset.optionSetType === 'radio'" :formData="formData" :parentId="`${parentId}_${questionData.questionId}`" :radiogroupData="suboptionset" :radiogroupRef="`${questionRef}_suboptionset${index2}`" :locked="locked"></stu-radio-group>
      <stu-checkbox-group :changeFunction="changeFunction" v-else-if="suboptionset.optionSetType === 'checkbox'" :formData="formData" :parentId="`${parentId}_${questionData.questionId}`" :checkboxgroupData="suboptionset" :checkboxgroupRef="`${questionRef}_suboptionset${index2}`" :locked="locked"></stu-checkbox-group>
    </div>
    <div v-for="(subquestion, index4) in questionData.questionSubQuestionList" :key="index4">
      <stu-question :changeFunction="changeFunction" :formData="formData" :parentId="`${parentId}_${questionData.questionId}`" :questionData="subquestion" :questionRef="`${questionRef}_subquestion${index4}`" :locked="locked"></stu-question>
    </div>
  </el-form-item>
</template>
<script>

export default {
  name: "stu-question",
  data() {
    return {
      btnloading: false,
    }
  },
  props: {
    questionData: {
      type: Object
    },
    questionRef: {
      type: String
    },
    formData: {
      type: Object
    },
    changeFunction: {
      type: Function
    },
    parentId: {
      type: String
    },
    locked: {
      type: Boolean
    }
  },
  methods: {
  },
  watch: {
  },
  computed: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
};
</script>


// WEBPACK FOOTER //
// src/views/msma/components/StuQuestion.vue